export enum HttpContentType {
  APPLICATION_JSON = 'application/json',
  FORM_DATA = 'multipart/form-data',
  FORM_DATA_WITH_BOUNDARY = 'multipart/form-data; boundary'
}
